export function isElectronMac(): boolean {
  return (
    typeof navigator === "object" &&
    typeof navigator.userAgent === "string" &&
    navigator.userAgent.indexOf("Electron") >= 0 &&
    navigator.userAgent.indexOf("Macintosh") >= 0
  );
}
